import { Globe2, Award, Stethoscope, Lock } from "lucide-react";

const PILLARS = [
  {
    icon: Globe2,
    title: "Globalne doświadczenie",
    desc: "Korzystamy z technologii wiodących ośrodków na świecie.",
  },
  {
    icon: Award,
    title: "Certyfikowana jakość",
    desc: "Normy gwarantujące najwyższą dokładność wyników.",
  },
  {
    icon: Stethoscope,
    title: "Wsparcie ekspertów",
    desc: "Jasna interpretacja wyniku i wsparcie specjalistów.",
  },
  {
    icon: Lock,
    title: "Pełna dyskrecja",
    desc: "Ochrona danych zgodna z rygorystycznymi normami.",
  },
];

export default function TrustPillars() {
  return (
    <section
      data-testid="trust-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="nuuma-container">
        <div className="max-w-2xl mx-auto text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-nuuma-secondary mb-3">
            Dlaczego nam zaufasz
          </span>
          <h2 className="font-display font-bold text-nuuma-primary text-3xl sm:text-4xl lg:text-[2.6rem] leading-[1.15]">
            Kiedy pytania są trudne,{" "}
            <span className="text-[#db8f8e]">
              genetyka
            </span>{" "}
            pomaga znaleźć odpowiedzi
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[30px]">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={i}
                data-testid={`trust-card-${i}`}
                className="text-center lg:text-left p-6 rounded-nuuma-m bg-nuuma-grey100/50 hover:bg-nuuma-grey100 transition-colors"
              >
                <div className="h-12 w-12 mx-auto lg:mx-0 rounded-xl bg-white border border-nuuma-grey200 flex items-center justify-center mb-4 shadow-nuuma-s">
                  <Icon className="h-5 w-5 text-nuuma-primary" />
                </div>
                <h4 className="font-display font-bold text-nuuma-primary text-[1.05rem] mb-2">
                  {p.title}
                </h4>
                <p className="text-sm text-nuuma-grey700 leading-relaxed">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
